<template>
  <main-sidebar :name="name" :title="$t('tax_return')">
    <div class="p-4">
      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <label>{{ $t('client') }}</label>
          <v-select
            :options="clients"
            label="ShortName"
            :reduce="client => client.ClientId"
            v-model="client"
            v-validate="'required'"
            name="client"
            class="w-full"
            :disabled="isEditing"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" class="mb-4">
        <!-- <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <label for="">Period</label>
        </vs-col> -->
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-input
            name="year"
            icon-pack="feather"
            icon="icon-calendar"
            v-model="year"
            v-mask="'####'"
            v-validate="{ required: true, min_value: 2000, max_value: 9999 }"
            :placeholder="$t('year')"
            icon-no-border
            class="w-full pr-2"
          />
        </vs-col>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-input
            icon-pack="feather"
            icon="icon-hash"
            v-model="month"
            v-mask="'##'"
            :placeholder="$t('month')"
            icon-no-border
            class="w-full pl-2"
            @input="checkMonth"
          />
        </vs-col>
        <vs-col vs-w="12">
          <span class="text-danger text-sm" v-show="errors.has('year')"
            >{{ errors.first('year') }}
          </span>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-input
            name="total"
            icon-pack="feather"
            icon="icon-dollar-sign"
            :placeholder="$t('total')"
            v-model.number="total"
            v-validate="{
              required: true,
              min_value: 1,
              max_value: 99999999.99,
              decimal: 2
            }"
            icon-no-border
            class="w-full"
            autocomplete="off"
          />
        </vs-col>
        <vs-col vs-w="12">
          <span class="text-danger text-sm" v-show="errors.has('total')">{{
            errors.first('total')
          }}</span>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <UploadFile
            v-model="files"
            list
            btnColor="#7367F0"
            class="w-full"
            btnClass="w-full"
            accept="application/pdf"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" class="mb-4">
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="pr-2"
        >
          <vs-button
            type="filled"
            color="primary"
            @click="submitForm"
            class="w-full"
            :disabled="this.isEditing ? disabledUpdate : disabledStore"
            >{{ $t('submit') }}</vs-button
          >
        </vs-col>
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          class="pl-2"
        >
          <vs-button
            type="border"
            color="primary"
            @click="close"
            class="w-full"
            >{{ $t('cancel') }}</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import UploadFile from '@/views/components/UploadFile'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import client from '@/http/requests/client'

export default {
  components: {
    MainSidebar,
    UploadFile,
    InputDate,
    vSelect
  },
  props: {
    tax: {
      type: Object,
      default: null
    },
    clients: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit || this.loading.client
    },
    disabledStore() {
      return (
        this.client === null ||
        this.year === '' ||
        this.month === '' ||
        this.total === '' ||
        this.files.length === 0 || this.errors.any()
      )
    },
    disabledUpdate() {
      return (
        this.client === null ||
        this.year === '' ||
        this.month === '' ||
        this.total === '' || this.errors.any()
      )
    },

    isEditing() {
      return this.tax !== null
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading()
      } else {
        this.closeLoading()
      }
    }
  },
  data: () => ({
    name: 'tax-return',
    client: null,
    year: '',
    month: '',
    total: '',
    files: [],
    loading: {
      submit: false
    }
  }),
  methods: {
    init() {
      this.clear()
       this.$validator.reset()
      if (this.isEditing) {
        let period = this.tax.period.split('-')
        this.year = period[0]
        this.month = period[1]
        let n = Number(this.tax.total) 
        this.total = n.toFixed(2)
        //this.total = this.tax.total
        //this.total = formatNumber(this.tax.total,2)
      }
      this.client == this.isEditing
        ? this.tax.client_id
        : this.clients[0].ClientId
    },
    clear() {
      this.year = ''
      this.month = ''
      this.total = ''
      this.files = []
      this.client = this.clients[0].ClientId
    },
    submitForm() {
      if (this.month < 10 && this.month.length === 1) {
        this.month = `0${this.month}`
      }
      let data = new FormData()
      data.append('year', this.year)
      data.append('month', this.month)
      data.append('total', this.total)
      if (this.files.length > 0) {
        data.append('file', this.files[0])
      }

      if (this.isEditing) {
        data.append('tax_id', this.tax.id)
        this.updateTax(data)
      } else {
        data.append('client_id', this.client)
        this.addTax(data)
      }
    },
    addTax(data) {
      this.loading.submit = true
      this.$store
        .dispatch('accounting/addTax', data)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added'
          })
          this.$store.dispatch('toggleSidebar', '')
          this.clear()
          this.loading.submit = false
        })
        .catch(err => {
          this.loading.submit = false
          if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function(key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR'
            })
          }
        })
    },
    updateTax(data) {
      this.loading.submit = true
      this.$store
        .dispatch('accounting/updateTax', data)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Updated'
          })
          this.$store.dispatch('toggleSidebar', '')
          this.clear()
          this.loading.submit = false
        })
        .catch(err => {
          this.loading.submit = false
          if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function(key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR'
            })
          }
        })
    },
    close() {
      this.clear()
      this.$store.dispatch('toggleSidebar', '')
    },
    openLoading() {
      this.$vs.loading({
        container: `#loading-${this.name}-sidebar`,
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close(`#loading-${this.name}-sidebar > .con-vs-loading`)
    },
    checkMonth() {
      if (this.month > 12) {
        this.month = 12
      }
    }
  }
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 100px;
}

</style>
